module.exports = __webpack_public_path__ + "static/media/pomodoro_timer.b2ce39c5.mp3";